import React, { FunctionComponent } from "react";

import styled from "styled-components";

import ArrowDiagonal from "../../icons/arrow-diagonal";

interface ExploreArtistsProps {
  className?: string;
}

const ExploreArtists: FunctionComponent<ExploreArtistsProps> = ({
  className,
}) => {
  const cosignLink = "https://cosign.trac.co/";
  return (
    <a
      className={className || ""}
      href={cosignLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <h4>Explore artists</h4>
      <ArrowDiagonal className="arrow" />
    </a>
  );
};

export default styled(ExploreArtists)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  overflow: visible;
  transform-origin: right top;

  h4 {
    color: ${({ theme }) => theme.colors.textGrey};
    font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
    opacity: 0.5;
  }

  h4,
  .arrow {
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
    path {
      transition: opacity
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`};
    }
  }

  &:hover {
    h4,
    .arrow {
      opacity: 1;
      path {
        opacity: 1;
      }
    }
  }
`;
